'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _UserHeader = require('./components/UserHeader.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_UserHeader).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-header/lib/components/user-header/index.js
// module id = 1556
// module chunks = 1